import _ from 'underscore';
import { CampaignApiError } from './campaign-api-error';
import { CampaignEditorialError } from './campaign-editorial-error';

function isErrorType(Type, obj) {
  return obj instanceof Type;
}

export const isCampaignApiError = _.partial(isErrorType, CampaignApiError);
export const isCampaignEditorialError = _.partial(isErrorType, CampaignEditorialError);
